import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import LoadingAnimation from './LoadingAnimation';
import Footer from './Footer';

const Prayer = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [prayer, setPrayer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrayer = async () => {
      try {
        const snap = await getDoc(doc(db, 'prayers', id));
        if (snap.exists() && snap.data().status !== 'deleted') {
          setPrayer({ id: snap.id, ...snap.data() });
        } else {
          navigate('/prayers');
        }
      } catch (err) {
        console.error('Error fetching prayer:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchPrayer();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <div className="stt-page"><LoadingAnimation /></div>;
  if (!prayer) return null;

  return (
    <div className="stt-page">
      <div className="stt-content">
        <div className="stt-article">
          <p style={{ marginBottom: '20px' }}>
            <a href="/prayers" className="stt-admin-back">← All Prayers</a>
          </p>

          <h1 className="stt-article-title">{prayer.name}</h1>

          {(prayer.categories || []).length > 0 && (
            <p className="stt-article-meta" style={{ borderBottom: 'none', paddingBottom: 0, marginBottom: '12px' }}>
              {prayer.categories.map(cat => (
                <span key={cat} className="stt-prayer-tag" style={{ marginRight: '6px' }}>{cat}</span>
              ))}
            </p>
          )}

          {prayer.description && (
            <p style={{
              fontStyle: 'italic',
              color: 'var(--color-secondary)',
              fontSize: '0.95rem',
              marginBottom: '28px',
              paddingBottom: '20px',
              borderBottom: '1px solid var(--divider)'
            }}>
              {prayer.description}
            </p>
          )}

          <div
            className="stt-prayer-content ql-editor"
            dangerouslySetInnerHTML={{ __html: prayer.content }}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Prayer;
